import { render, staticRenderFns } from "./PatientRemoveModal.vue?vue&type=template&id=014b97f1&"
import script from "./PatientRemoveModal.vue?vue&type=script&lang=js&"
export * from "./PatientRemoveModal.vue?vue&type=script&lang=js&"
import style0 from "./PatientRemoveModal.vue?vue&type=style&index=0&id=014b97f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports